// const API_BASE_URL = "https://cryptotradeapi.solvyxx.com/api/v1";
// const API_BASE_URL = "https://metaadmin.online/api/v1";
const API_BASE_URL = "https://proit99.online/api/v1";

// const API_BASE_URL = "http://localhost:5000/api/v1";

export default API_BASE_URL;
